import script from "./Information.vue?vue&type=script&setup=true&lang=js"
export * from "./Information.vue?vue&type=script&setup=true&lang=js"

import "./Information.vue?vue&type=style&index=0&id=bada4374&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bada4374"]])

export default __exports__